/* eslint-disable no-nested-ternary */
import parse from 'html-react-parser';
import { forEach, toNumber, isEmpty, startsWith } from 'lodash';

// local dependencies
import { isIosApp } from 'core/modules/device-detect';
import shortid from 'shortid';

export const icon = ( props ) => {

	// extract `name` or `id` from props and store in 'id'.
	const id = props.name || props.id;

	if( isEmpty( id ) || isEmpty( props[ id ] ) ) {
		return null;
	}

    // Get the default styles object from config otherwise initialise it to an empty object {}.
	const defaultStyles = props[ id ].defaultStyles ? props[ id ].defaultStyles : {};

    // Get the markup for the icon otherwise initialise it to an empty string.
	const markup = props[ id ].markup ? props[ id ].markup : '';

	// Extract all style-related props and set some default values in case there is no prop for that property.
	const size = props.size ? props.size : 30;

	const width = props.width ? props.width : defaultStyles.width? defaultStyles.width : size;

	const height = props.height ? props.height : defaultStyles.height? defaultStyles.height : size;

	const rotate = props.rotate ? toNumber( props.rotate ) : defaultStyles.rotate? toNumber( defaultStyles.rotate ) : 0;

	const fill = props.fill ? props.fill : defaultStyles.fill? defaultStyles.fill : 'none';

	const stroke = props.stroke ? props.stroke : defaultStyles.stroke ? defaultStyles.stroke : '#999999';

	const opacity = props.opacity ? toNumber( props.opacity ) : defaultStyles.opacity? toNumber( defaultStyles.opacity ) : 1;

	const transform = `rotate(${rotate})`;

    // Create the custom style object by props sent.
    const customStyles = {
		transform,
		fill,
		stroke,
        opacity,
        width,
		height,
		uuida: shortid.generate(),
		uuidb: shortid.generate(),
		...props.customIconStyles
	};

    // Merge default styles from config with custom styles sent through props:
    const style = { ...defaultStyles, ...customStyles, focusable: false  }; // focusbale is set to false to disable on focus for svg icons in input field

    // Override the style placeholders in the markup with our merged style object:
	let replacedMarkup = replaceMarkupPlaceHolders( markup, style );

	// replace `filter="url()"` attribute when iOS app (not supported)
	if( isIosApp() ) {
		replacedMarkup = replacedMarkup.replace( /filter="url\(#[\w]+\)"/gmi, '' );
	}

	// Parse the replacedMarkup using html-react-parser and return the markup.
    return parse( replacedMarkup );

};

/**
 * @desc this method is used to replace the placeholders in the markup by picking up their corresponding values from
 * the defaultStyles object in the iconConfig.
 * @param {*} markup
 * @param {*} style
 */
const replaceMarkupPlaceHolders = ( markup, style ) => {

	forEach( style, ( value, property ) => {
		const propertyToBeChanged = 'Fill' === property ? 'fill' : property;

		if( startsWith( property, 'uuid' ) ) {
			markup = markup.replace( new RegExp( `__${ property }__`, 'gim' ), value );
		} else {
			markup = markup.replace( new RegExp( `__${ property }__`, 'gim' ), `${ propertyToBeChanged }=${ value }` );
		}

	} );

	return markup;
};
